import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface NoRecordFoundProps {}
const NoRecordFound: React.FC<NoRecordFoundProps> = ({}) => {
  const { t } = useTranslation();
  return (
    <Typography
      variant="subtitle2"
      component="div"
      sx={{
        py: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {t("common.messages.noRecordsFound")}
    </Typography>
  );
};
export default NoRecordFound;
